<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "serviceCategory",
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "上级分类",
          name: "pid",
          value: 0,
          type: "tree",
          dropList: [{ value: 0, name: "主分类" }],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "名称",
          name: "name",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "图片",
          name: "image",
          value: "",
          type: "image",
          desc: "图片尺寸最低256*256像素比例",
          rules: [{ required: false, trigger: "blur" }],
        },
        {
          label: "状态",
          name: "status",
          value: 1,
          type: "switch",
          trueValue: 1,
          falseValue: 2,
        },
      ],
      forms: {},
    };
  },
  created() {
    this.loadDropTree(); ////暂时隐藏 不创建子分类
    // this.loadItemsFieldDrop('serviceCategoryDropTree', 'pid')
  },
  methods: {
    async loadDropTree() {
      // 通过pk查询字典数据
      let q = {};
      let res = await $utils.api.load("serviceCategoryDropTree", q);
      if (res && res.data) {
        let ll = res.data;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.value;
          xx.name = element.name;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "pid") {
            this.items[index]["dropList"] = (this.items[index]["dropList"] || []).concat(
              dropList
            );
          }
        }
      }
    },
  },
};
</script>
